<template>
  <div class="faded_border_bottom">
    <div class="is-flex is-justify-content-space-between">
      <div>
        <LinkEntity :payload="offer.applicant"></LinkEntity>
        <p :ref="'applicant_info_' + offer.id">
          <b>שם המועמד:</b> <span style="background: yellow">{{ fullName }}</span> <span v-if="offer.applicant.is_discrete">(דיסקרטי)</span>
          <br>
          <b>מספר טלפון:</b> {{ offer.applicant.phone_number }}
        </p>
        <div>
          <textarea class="min-heigh-80" placeholder="מידע נוסף..." v-model="extra_info"></textarea>
        </div>
        <p v-if="mutable_offer.applicant_abstract" v-html="$sanitize(mutable_offer.applicant_abstract)" class="abstract"></p>
        <div>
          <div class="margin-top">
            <Files ref="files" :payload="{ applicant_data: offer.applicant }"></Files>
          </div>
        </div>
      </div>
      <div class="margin-right">
        <CvOfferAlerts :offer="offer" class="font-size-12"></CvOfferAlerts>
      </div>
    </div>
    <br>
    <br>
  </div>
</template>
<script>
import Files from '@/components/Files'
import CvOfferAlerts from '@/components/CvOfferAlerts'
import LinkEntity from '@/components/LinkEntity'
export default {
  name: 'email-position-applicant',
  props: ['offer'],
  data () {
    return {
      mutable_offer: this.offer,
      extra_info: ''
    }
  },
  computed: {
    fullName () {
      return this.offer.applicant.full_name
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getAbstract()
    },
    getAbstract () {
      this.mutable_offer.applicant_abstract = this.offer.applicant.abstract
      this.$forceUpdate()
    },
    getSelectedFiles () {
      return this.$refs.files.getCheckedFiles().map(file => {
        file.applicant = this.mutable_offer.applicant
        return file
      })
    },
    getInfo () {
      let extra_info = this.extra_info.length > 0 ? this.extra_info.replace(/\n/g, '<br>') + '<br>' : ''
      let abstract = this.mutable_offer.applicant_abstract != undefined && this.mutable_offer.applicant_abstract.length > 0 ? this.mutable_offer.applicant_abstract + '<br><br>' : ''
      let applicant_name_and_phone = this.$refs[`applicant_info_${this.offer.id}`].innerHTML
      return applicant_name_and_phone + '<br><br>' + extra_info + abstract + '⸻'
    },
    getTextInfo () {
      let extra_info = this.extra_info.length > 0 ? this.extra_info.replace(/\n/g, '<br>') + '<br>' : ''
      let abstract = this.mutable_offer.applicant_abstract != undefined && this.mutable_offer.applicant_abstract.length > 0 ? this.mutable_offer.applicant_abstract : ''
      return extra_info + abstract
    }
  },
  components: {
    Files,
    CvOfferAlerts,
    LinkEntity
  }
}
</script>
<style scoped>
  .abstract {
    word-break: break-word;
    max-width: 700px;
  }
</style>
